export default __webpack_public_path__ + "static/dorian_martin-c18660642e9b9f3e346823b31b8baccf.jpg";